module.exports = __webpack_public_path__ + "img/img5.f29ba1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img5.png
// module id = 236
// module chunks = 0